import React from "react";
import ReactDOM from "react-dom";

import { MsalProvider } from "@azure/msal-react";
import Axios, { AxiosResponse } from "axios";
import { Provider } from "react-redux";

import App from "./App";
import { authContext, setAdCredentials } from "./services/authentication";
import store from "./store";

import "./index.scss";
import "./services/translation/i18n";

Axios.get("/api/environment").then((result: AxiosResponse) => {
	setAdCredentials(result.data.tenantId, result.data.clientId);
	ReactDOM.render(
		<MsalProvider instance={authContext()}>
			<Provider store={store}>
				<App />
			</Provider>
		</MsalProvider>,
		document.getElementById("root")
	);
});
